import { render, staticRenderFns } from "./FBLoginButton.vue?vue&type=template&id=1561e931&scoped=true&"
import script from "./FBLoginButton.vue?vue&type=script&lang=js&"
export * from "./FBLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1561e931",
  null
  
)

export default component.exports